import React, { useState } from "react";
import { IoHomeOutline } from "react-icons/io5";
import { CiSettings } from "react-icons/ci";
import FamilyProfiles from "./AddFamily";
import SettingsPage from "./SettingsPage";

const HubPage = ({ onBack }) => {
  const [showProfiles, setShowProfiles] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [sliderValues, setSliderValues] = useState({
    Fun: 60,
    Bonding: 60,
    Learning: 60,
  });
  const profiles = [
    { name: "Karen", image: "/images/avatar1.png" },
    { name: "Darren", image: "/images/avatar2.png" },
    { name: "Sharon", image: "/images/avatar3.png" },
    // { name: "Joan", image: "/images/avatar4.png" },
    // { name: "Joan", image: "/images/avatar5.png" },

  ];

  const funSegments = [
    { min: 0, max: 20, opacity: 0.2, icon: "🤔" },
    { min: 20, max: 40, opacity: 0.4, icon: "🧐" },
    { min: 40, max: 60, opacity: 0.6, icon: "🧠" },
    { min: 60, max: 80, opacity: 0.8, icon: "🧑‍🔬" },
    { min: 80, max: 100, opacity: 1, icon: "🧙‍♀️" },
  ];

  const bondingSegments = [
    { min: 0, max: 20, opacity: 0.2, icon: "🖇️" },
    { min: 20, max: 40, opacity: 0.4, icon: "🪇" },
    { min: 40, max: 60, opacity: 0.6, icon: "🫶" },
    { min: 60, max: 80, opacity: 0.8, icon: "❤️" },
    { min: 80, max: 100, opacity: 1, icon: "❤️‍🔥" },
  ];

  const learningSegments = [
    { min: 0, max: 20, opacity: 0.2, icon: "🙂" },
    { min: 20, max: 40, opacity: 0.4, icon: "😄" },
    { min: 40, max: 60, opacity: 0.6, icon: "🥳" },
    { min: 60, max: 80, opacity: 0.8, icon: "🤩" },
    { min: 80, max: 100, opacity: 1, icon: "😱" },
  ];

  if (showSettings) {
    return <SettingsPage onBack={() => setShowSettings(false)} />;
  }

  if (showProfiles) {
    return (
      <FamilyProfiles
        onBack={() => {
          setShowProfiles(false);
          setIsEditMode(false);
        }}
        onComplete={() => {
          setShowProfiles(false);
          setIsEditMode(false);
        }}
        isEditMode={isEditMode}
      />
    );
  }

  const getCurrentSegment = (value, segments) => {
    return segments.find(
      (segment) => value >= segment.min && value <= segment.max
    );
  };

  const createSegmentedBackground = (value, segments, activeColor) => {
    const totalSegments = segments.length;
    let background = [];

    segments.forEach((segment, index) => {
      const segmentStart = (index / totalSegments) * 100;
      const segmentEnd = ((index + 1) / totalSegments) * 100;

      if (value >= segment.max) {
        background.push(
          `${activeColor} ${segment.opacity}) ${segmentStart}% ${segmentEnd}%`
        );
      } else if (value >= segment.min && value <= segment.max) {
        const percentage = (value - segment.min) / (segment.max - segment.min);
        const gradientEnd =
          segmentStart + (segmentEnd - segmentStart) * percentage;
        background.push(
          `${activeColor} ${segment.opacity}) ${segmentStart}% ${gradientEnd}%`
        );
        background.push(
          `rgba(200, 200, 200, 0.4) ${gradientEnd}% ${segmentEnd}%`
        );
      } else {
        background.push(
          `rgba(200, 200, 200, 0.4) ${segmentStart}% ${segmentEnd}%`
        );
      }
    });

    return `linear-gradient(90deg, ${background.join(", ")})`;
  };

  const sliders = [
    {
      label: "Fun",
      value: sliderValues.Fun,
      segments: funSegments,
      color: "rgba(254, 163, 117,",
      bgColor: "bg-[#FEA375]",
    },
    {
      label: "Bonding",
      value: sliderValues.Bonding,
      segments: bondingSegments,
      color: "rgba(246, 179, 246,",
      bgColor: "bg-[#F6B3F6]",
    },
    {
      label: "Learning",
      value: sliderValues.Learning,
      segments: learningSegments,
      color: "rgba(96, 183, 255,",
      bgColor: "bg-[#60B7FF]",
    },
  ];

  const handleSliderMove = (e, label) => {
    e.preventDefault();
    const slider = e.currentTarget;
    const rect = slider.getBoundingClientRect();
    const x =
      "touches" in e ? e.touches[0].clientX - rect.left : e.clientX - rect.left;
    const percentage = Math.min(Math.max((x / rect.width) * 100, 0), 100);

    const step = 20;
    const snappedValue = Math.round(percentage / step) * step;

    setSliderValues((prev) => ({
      ...prev,
      [label]: snappedValue,
    }));
  };

  return (
    <div
      className="min-h-screen p-6"
      style={{
        backgroundImage:
          "linear-gradient(to bottom, #FBCFE8 3%, #FFFFFF 6%, #FAFAFA 100%)",
      }}
    >
      {/* Header */}
      <div className="w-full flex items-center justify-center mx-6 my-1">
        {/* Back Button */}
        <div className="fixed top-[34px] left-5 z-20">
          <button
            onClick={() => setShowSettings(true)}
            className="bg-white rounded-full p-1 shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
          >
            <CiSettings className="w-6 h-6 text-gray-400" />
          </button>
        </div>
        <h1
          style={{
            wordBreak: "break-word",
          }}
          className="text-[20px] leading-[28px] flex-wrap font-normal font-young-serif text-[#3A1A1A] text-center"
        >
            {/* dynamic name 20 chars */}
          12345678901234567890 <br />
          family
        </h1>
        <div className="w-6"></div>
      </div>

      {/* Profiles */}
      <div className="flex flex-col gap-8 mb-6 mt-4">
      <div className={`flex items-center ${profiles.length >= 4 ? 'justify-around' : 'justify-center gap-4'}`}>
    {profiles.slice(0, 4).map((profile, index) => (
      <div key={index} className="flex flex-col items-center">
        <div className="w-[4.5rem] h-[4.5rem] overflow-hidden rounded-full border-2 border-grey-800 p-[8px]">
          <div className="w-full h-full rounded-full bg-white">
            <img
              src={profile.image}
              alt={`${profile.name}'s profile`}
              className="w-full h-full rounded-full object-cover"
            />
          </div>
        </div>
        <p className="text-[14px] font-space-grotesk font-medium text-[#1E0A1E] mt-1">{profile.name}</p>
      </div>
    ))}
  </div>
  <div className="flex items-center justify-center">
    {profiles.slice(4).map((profile, index) => (
      <div key={index} className="flex flex-col items-center">
        <div className="w-[4.5rem] h-[4.5rem] overflow-hidden rounded-full border-2 border-grey-800 p-[8px]">
          <div className="w-full h-full rounded-full bg-white">
            <img
              src={profile.image}
              alt={`${profile.name}'s profile`}
              className="w-full h-full rounded-full object-cover"
            />
          </div>
        </div>
        <p className="text-[14px] font-space-grotesk font-medium text-[#1E0A1E] mt-1">{profile.name}</p>
      </div>
    ))}
  </div>
</div>

      {/* Edit Profiles Button */}
      <div className="flex justify-center mb-9">
        <button
          onClick={() => {
            setShowProfiles(true);
            setIsEditMode(true);
          }}
          className="w-[35%] max-w-md text-[16px] font-space-grotesk font-medium bg-[#1E0A1E] text-[#EEEEEE] py-2 rounded-full shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
        >
          Edit Profiles
        </button>
      </div>

      {/* Progress Section */}
      <h2 className="text-[20px] font-normal text-[#1A1A1A] text-center font-young-serif mb-5">
        Your progress
      </h2>
      <div className="flex flex-col gap-4 mb-16 relative">
        <div className="p-4 text-center"  style={{
          background: `url("/images/hubprogress1.svg")`,
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
        }}>
          <div className="absolute top-4 left-1/2 transform -translate-x-1/2">
            <img src="/images/star.svg" alt="Black Fire" className="w-6 h-6" />
          </div>
          <p className="text-[60px] font-normal text-[#1E0A1E] font-bagel mb-2 mt-4">
            00023
          </p>
          <p className="text-[16px] leading-[16px] text-[#1E0A1E] font-normal font-young-serif">
            Your Famjam <br /> Points
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div
            style={{
                background: `url("/images/hubprogress2.svg")`,
                backgroundSize: "100% 100%",
                backgroundRepeat: "no-repeat",
              }}
            className=" p-4 text-center relative"
          >
            <div className="absolute top-4 left-1/2 transform -translate-x-1/2">
              <img
                src="/images/fire.png"
                alt="Black Fire"
                className="w-6 h-6"
              />
            </div>
            <p className="text-[60px] font-normal text-[#1E0A1E] font-bagel mt-4">
              12
            </p>
            <p className="text-[16px] leading-[16px] text-[#1E0A1E] font-normal font-young-serif">
              Longest Day Streak
            </p>
          </div>
          <div className="p-4 text-center relative" style={{
                background: `url("/images/hubprogress3.svg")`,
                backgroundSize: "100% 100%",
                backgroundRepeat: "no-repeat",
              }}>
            <div className="absolute top-4 left-1/2 transform -translate-x-1/2">
              <img
                src="/images/flag.svg"
                alt="Black Fire"
                className="w-6 h-6"
              />
            </div>
            <p className="text-[60px] font-normal text-[#1E0A1E] font-bagel mt-4">
              398
            </p>
            <p className="text-[16px] leading-[16px] text-[#1E0A1E] font-normal font-young-serif">
              Fanjams Complete
            </p>
          </div>
        </div>
      </div>

      {/* Your Values */}
      <h2 className="text-[20px] font-normal text-[#1E0A1E] text-center font-young-serif mb-5">
        Your values
      </h2>
      <div className="flex flex-col gap-3 mb-11">
        <div className="bg-[#60B7FF80] rounded-[20px] p-4 w-full flex items-start">
          <h3 className="text-[20px] font-normal font-young-serif text-[#1E0A1E] min-w-[120px]">
            Respect
          </h3>
          <p className="pl-[26px] text-[16px] font-space-grotesk text-[#1E0A1E] leading-[19px]">
            We treat each other kindly and listen with open hearts
          </p>
        </div>

        <div className="bg-[#60B7FF80] rounded-[20px] p-4 w-full flex items-start">
          <h3 className="text-[20px] font-normal font-young-serif text-[#1E0A1E] min-w-[120px]">
            Playfulness
          </h3>
          <p className=" pl-[26px] text-[16px] font-space-grotesk text-[#1E0A1E] leading-[19px]">
            We fill our days with laughter, fun, and adventure together.
          </p>
        </div>

        <div className="bg-[#60B7FF80] rounded-[20px] p-4 w-full flex items-start">
          <h3 className="text-[20px] font-normal font-young-serif text-[#1E0A1E] min-w-[120px]">
            Integrity
          </h3>
          <p className="pl-[26px] text-[16px] font-space-grotesk text-[#1E0A1E] leading-[19px]">
            We're honest, reliable, and support each other to be our best.
          </p>
        </div>
      </div>
      {/* Fanjam Vibe */}
      <h2 className="text-[20px] font-normal text-[#1E0A1E] text-center font-young-serif pt-3 mb-5">
        Your Famjam vibe
      </h2>

      <div className="bg-[#FFFFFF] rounded-[2rem] p-4 pb-10 shadow-sm mb-8">
        <p className="pb-[34px] text-[16px] leading-[19px] text-[#1E0A1E] text-center font-normal font-space-grotesk">
          Tweak the weighting
          <br /> of your daily <b>Famjam</b>
        </p>
        <div className="w-full flex flex-col gap-12">
          {sliders.map((slider, index) => (
            <div key={index} className="flex items-center w-full gap-4">
              <label className="text-[16px] font-normal leading-[16px] text-left font-young-serif text-[#3A1A1A] min-w-[80px]">
                {slider.label}
              </label>
              <div
                className="relative flex items-center flex-grow"
                onMouseDown={(e) => handleSliderMove(e, slider.label)}
                onTouchStart={(e) => handleSliderMove(e, slider.label)}
                onTouchMove={(e) => handleSliderMove(e, slider.label)}
                onMouseMove={(e) => {
                  if (e.buttons) handleSliderMove(e, slider.label);
                }}
              >
                <div
                  className="absolute left-0 top-1/2 transform -translate-y-1/2 h-3 w-full rounded-full"
                  style={{
                    background: createSegmentedBackground(
                      slider.value,
                      slider.segments,
                      slider.color
                    ),
                  }}
                ></div>
                <input
                  type="range"
                  min="0"
                  max="100"
                  step="20"
                  value={slider.value}
                  onChange={(e) =>
                    setSliderValues((prev) => ({
                      ...prev,
                      [slider.label]: parseInt(e.target.value),
                    }))
                  }
                  className="relative appearance-none w-full h-4 bg-transparent outline-none"
                  style={{ WebkitAppearance: "none", appearance: "none" }}
                />
                <div
                  className={`absolute top-1/2 transform -translate-y-1/2 -translate-x-1/2 flex items-center justify-center h-9 w-9 rounded-full shadow-lg ${slider.bgColor}`}
                  style={{
                    left: `${slider.value}%`,
                  }}
                >
                  <span
                    role="img"
                    aria-label={`${slider.label} Emoji`}
                    className="text-[20px]"
                  >
                    {getCurrentSegment(slider.value, slider.segments).icon}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <footer className="w-full flex flex-col items-center sticky bottom-4 z-10 py-2">
        <div className="relative">
          <div className="bg-white rounded-full px-8 py-2 flex space-x-12 shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]">
            <button
              onClick={onBack}
              className="flex flex-col items-center text-black relative"
            >
              <IoHomeOutline className="text-2xl text-[#929292]" />
              <span className="text-[10px] text-[#929292] font-bold mt-0.5 font-space-grotesk">
                Home
              </span>
            </button>
            <button className="flex flex-col items-center text-gray-400">
              <img
                src="/images/active-user-group.svg"
                alt="Hub Icon"
                className="w-6 h-6"
              />
              <span className="text-[10px] text-[#1E0A1E] mt-0.5 font-bold font-space-grotesk">
                Hub
              </span>
            </button>
          </div>
          <div className="absolute -bottom-4.5 left-1/2 transform -translate-x-1/2 w-32 h-1.5 bg-black rounded-full mt-3"></div>
        </div>
      </footer>
    </div>
  );
};

export default HubPage;
